/* eslint-disable max-len */
export default {
  // 教师禁用展示文案
  teacherDisableText: "Tutor's information is not found. Go find more of our outstanding tutors!",
  exceptionText: 'More excellent teachers are on the way. Please stay tuned.',
  teacher: 'our teacher',
  intro: {
    title: 'Our Math Master Teachers',
    describe: 'Even though our tutors have years of experience, after hiring, they enter a rigorous training process before we qualify them to lead a class; this is to ensure all our tutors are highly trained in helping students to reach their full potential',
  },
  detailTabs: [{ title: 'Profile', name: 'Profile' }, { title: 'Courses', name: 'Courses' }],
  achievement: 'Achievements',
  longTerm: 'Long Term Course',
  shortTerm: 'Short Term Course',
}
